import { ReactElement, ReactNode } from 'react'
import styles from './CookieBanner.module.scss'
import { useMatchMedia } from '../../hooks/useMatchMedia'
import { pageBreakpoints } from '../../config/pageBreakpoints'
import {
  DesktopButton,
  DesktopTitleMedium,
  MobileButton,
  MobileTitleMedium,
} from '../../Typography'
import clsx from 'clsx'
import { useCookieConsent } from '../../provider/CookieConsentProvider'

interface TextProps {
  isMobile: boolean
  children: ReactNode
}

const Text = ({ isMobile, children }: TextProps): ReactElement => {
  return isMobile ? (
    <MobileTitleMedium fontWeight={500} darkFont={true}>
      {children}
    </MobileTitleMedium>
  ) : (
    <DesktopTitleMedium fontWeight={500} darkFont={true}>
      {children}
    </DesktopTitleMedium>
  )
}

const Button = ({ isMobile, children }: TextProps): ReactElement => {
  return isMobile ? (
    <MobileButton>{children}</MobileButton>
  ) : (
    <DesktopButton>{children}</DesktopButton>
  )
}

export const CookieBanner = (): ReactElement | null => {
  const isMobile = useMatchMedia(`(max-width:${pageBreakpoints.md}`)
  const { consent, setConsent } = useCookieConsent()

  // If consent is already given or declined, don’t show banner
  if (consent !== null) return null

  const handleAccept = (): void => {
    setConsent(true)
  }

  const handleDecline = (): void => {
    setConsent(false)
  }

  const buttonStyles = isMobile ? styles.mobileButton : styles.webButton

  return (
    <div className={clsx(styles.cookieBannerOverlay, styles.visible)}>
      <div className={styles.contentColumn}>
        <Text isMobile={isMobile}>
          Wir verwenden auf unserer Website eingebettete Videos von YouTube. Dabei können
          personenbezogene Daten (z. B. Ihre IP-Adresse) an YouTube (Google Ireland Limited)
          übermittelt und Cookies auf deinem Gerät gespeichert werden. Die Datenverarbeitung erfolgt
          möglicherweise auch außerhalb der EU. Weitere Informationen findest du in unserer{' '}
          <a className={styles.link} href='/datenschutz' target='_blank'>
            Datenschutzerklärung
          </a>
          .
        </Text>
        <Text isMobile={isMobile}>
          Möchtest du YouTube-Videos auf dieser Website sehen, musst du der Verwendung von Cookies
          und der Datenübertragung an YouTube zustimmen.
        </Text>
        <div className={buttonStyles} onClick={handleAccept}>
          <Button isMobile={isMobile}>Cookies akzeptieren</Button>
        </div>
        <div className={buttonStyles} onClick={handleDecline}>
          <Button isMobile={isMobile}>Cookies ablehnen</Button>
        </div>
      </div>
    </div>
  )
}
